import { latLng, LatLngExpression } from 'leaflet';
import styles from './BeamsSVGLayer.module.scss';
import { SVGOverlay } from 'react-leaflet';
import { PropsWithChildren, ReactElement, useContext } from 'react';
import { BeamsParams, ObjectBeamsContext } from '@dmc/ui';

interface BeamsSVGLayerProps {
  position: LatLngExpression;
  beamsParams: BeamsParams | undefined;
}

export const BeamsSVGLayer = ({
  position,
  beamsParams,
  children,
}: PropsWithChildren<BeamsSVGLayerProps>): ReactElement | null => {
  // Read the context from the parent ObjectBeams
  const obj = useContext(ObjectBeamsContext);

  // Get the maximum outer radius of all of the object's beams (in metres).
  const radius = obj.getOuterRadiusFromOrigin(beamsParams);

  // If the radius is 0 (invalid body config) exit early.
  if (radius <= 0) return null;

  const diameter = radius * 2;
  const svgBounds = latLng(position).toBounds(diameter);

  return (
    <SVGOverlay
      // Leaflet does not detect/apply viewBox changes, so use the position and radius (bounds) to force a re-render.
      key={JSON.stringify(svgBounds)}
      attributes={{ viewBox: `${-radius} ${-radius} ${diameter} ${diameter}` }}
      className={styles.svgReset}
      bounds={svgBounds}
    >
      {children}
    </SVGOverlay>
  );
};
